/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} System_Status_Summary_SlowInputs */



/**
* | output |
* | --- |
* | "oneAI is running slower than usual right now." |
*
* @param {System_Status_Summary_SlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const system_status_summary_slow = /** @type {((inputs?: System_Status_Summary_SlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Status_Summary_SlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI ist derzeit langsamer als gewöhnlich.")
	return /** @type {LocalizedString} */ ("oneAI is running slower than usual right now.")
});